import React from "react";
import { Filter, Search, LayoutGrid, List, CalendarDays } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Input } from "../ui/input";
import { Button } from "../ui/button";

const STATUS_OPTIONS = [
  { value: 'todo', label: 'To Do' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'delayed', label: 'Delayed' },
  { value: 'completed', label: 'Completed' },
];

export const DashboardFilters = ({
  filters, setFilters, searchTerm, setSearchTerm, viewMode, setViewMode,
  sites, studies, users,
}) => (
  <Card className="border-0 shadow-lg" data-testid="dashboard-filters">
    <CardContent className="pt-6">
      <div className="flex flex-wrap gap-4 items-center">
        <div className="flex items-center gap-2"><Filter className="h-4 w-4 text-gray-500" /><span className="text-sm font-medium text-gray-700">Filters:</span></div>
        <Select value={filters.site} onValueChange={(value) => setFilters({ ...filters, site: value })}>
          <SelectTrigger className="w-40"><SelectValue placeholder="All Sites" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Sites</SelectItem>
            {sites.map(s => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={filters.study} onValueChange={(value) => setFilters({ ...filters, study: value })}>
          <SelectTrigger className="w-40"><SelectValue placeholder="All Studies" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Studies</SelectItem>
            {studies.map(s => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={filters.assignee} onValueChange={(value) => setFilters({ ...filters, assignee: value })}>
          <SelectTrigger className="w-40"><SelectValue placeholder="All Assignees" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Assignees</SelectItem>
            {users.map(u => <SelectItem key={u.id} value={u.name}>{u.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={filters.status} onValueChange={(value) => setFilters({ ...filters, status: value })}>
          <SelectTrigger className="w-40"><SelectValue placeholder="All Status" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Status</SelectItem>
            {STATUS_OPTIONS.map(opt => <SelectItem key={opt.value} value={opt.value}>{opt.label}</SelectItem>)}
          </SelectContent>
        </Select>
        <div className="relative flex-1 min-w-48">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input placeholder="Search tasks..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="pl-10" data-testid="task-search-input" />
        </div>
        <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
          <Button variant={viewMode === "kanban" ? "default" : "ghost"} size="sm" onClick={() => setViewMode("kanban")} data-testid="view-kanban"><LayoutGrid className="h-4 w-4" /></Button>
          <Button variant={viewMode === "list" ? "default" : "ghost"} size="sm" onClick={() => setViewMode("list")} data-testid="view-list"><List className="h-4 w-4" /></Button>
          <Button variant={viewMode === "calendar" ? "default" : "ghost"} size="sm" onClick={() => setViewMode("calendar")} data-testid="view-calendar"><CalendarDays className="h-4 w-4" /></Button>
        </div>
      </div>
    </CardContent>
  </Card>
);
